import {Text as RN_Text} from "react-native";

function Text(props: any) {
    return <RN_Text {...props}>{props.children}</RN_Text>;
}

export {Text};